<template>
  <div class="report-overview-container">
    <van-nav-bar
      title="汇报管理总览"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333"/>
      </template>
    </van-nav-bar>
     <div class="company-selection" @click="selectCompanyHandler">
      <span>{{ seletionData.company }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
    <div class="date-selection-warpper">
      <div class="date-selection"> 
        <div class="flex-warpper add-border"  @click="selectDateHandler">
          <span>{{ seletionDateData.selectedDate }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
      </div>
      <div class="date-show">
        <span>数据截止时间：</span>
        <span class="vei-mid">{{ seletionDateData.deadlineDate }}</span>
      </div>
    </div>
    
    <div class="overview-main">
        <van-search v-model="searchData" placeholder="请输入搜索关键词" @search="onSearch"/>
        <div class="date-selection-warpper marin-0">
          <div class="date-selection"> 
            <div class="flex-warpper"  @click="selectRangeHandler">
              <span>{{ seletionRangeData.currentRange }}</span>
              <i class="iconfont icon-xiangxiajiantou"></i>
            </div>
          </div>
          <div class="number-area">
            <span class="border-r">提交人数&nbsp;&nbsp;{{ seletionRangeData.submitPresonNum }}</span>
            <span class="vei-mid padding-l">汇报数量&nbsp;&nbsp;{{ seletionRangeData.reportNum }}</span>
          </div>
        </div>
        <div class="report-list-warpper">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="onLoad"
            >
              <van-cell is-link v-for="item in overviewList" :key="item.instanceId" @click="toFlowDeital(item.instanceId, item.initiatorName)">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <div class="reporter-info">
                    <img class="head-portrait" :src="item.avatar ? item.avatar : copyIcon" alt="">
                    <div>
                      <div class="author">{{ item.initiatorName }}</div>
                      <div class="flowName">
                        <span>流程名称：</span>
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="submitTime">
                        <span>提交时间：</span>
                        <span>{{ getDate("yyyy-MM-dd hh:mm:ss",item.createDate) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </van-cell>
            </van-list>
          </van-pull-refresh>
        </div>
    </div>
    <van-popup position="bottom" round v-model="showRangeType">
      <van-picker
        show-toolbar
        v-model="seletionRangeData.currentRange"
        value-key="modelName"
        :columns="rangeTypeOptions"
        @confirm="onRangeTypeConfirm"
        @cancel="showRangeType = false"
        ref="rangeType"
      />
    </van-popup>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker
        v-model="selectedDate"
        type="year-month"
        title="选择年月"
        :formatter="formatter"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-action-sheet>
    <van-overlay :show="showOverlay">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-loading size="1rem" vertical>加载中...</van-loading>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getPersonalReportBoard, getReportOverviewList, getRangeOptionsList } from "@/axios/services.js"
import copyIcon from '@/assets/propertyImg/copyIcon.png'
import { Toast } from 'vant'
export default {
  data () {
    return {
      showOverlay: false,
      showDatePicker: false,
      copyIcon,
      seletionDateData: {
        selectedDate: new Date().getDate() === 1 ? this.getDate("yyyy-MM", "yesterday") : this.getDate("yyyy-MM"),
        deadlineDate: this.getDate('yyyy-MM-dd', 'yesterday'),
      },
      searchData: "",
      seletionRangeData: {
        currentRange: "全部流程",
        modelId: "",
        submitPresonNum: 100,
        reportNum: 300,
      },
      seletionData: {
        company: "深圳华瀚投资控股有限公司 (全部)"
      },
      showRangeType: false,
      overviewList: [
        
      ],

      selectedDate: new Date().getDate() === 1 ? new Date() - 1000 * 60 * 60 : new Date(),
      error: false,
      pageInfo: {
        currentPage: 1,
        currentPageSize: 10,
        total: 0
      },
      loading: false,
      finished: false,
      refreshing: false,
      rangeTypeOptions: [],
      rangeParams: {
        companyId: localStorage.getItem("companyId") === "undefined" ? 
                  "cfe05dd2cedf4dd1ad9475d32838eaf9" : 
                  localStorage.getItem("companyId"),
        scopeType: 0,
      },
      companyInfo: {
        companyId: localStorage.getItem("companyId") === "undefined" ? 
                  "cfe05dd2cedf4dd1ad9475d32838eaf9" : 
                  localStorage.getItem("companyId"),
        scopeType: 0,
        officeId: ""
      },
      selectedCompany: []
    }
  },
  created () {
    
  },
  mounted () {
    // window.addEventListener("popstate", (e) => {
    //   window.history.pushState(null, null, "#");
    //   this.$router.push({
    //     path: "personal-report-board",
    //   })
    // })
  },
  activated () {
    this.seletionRangeData.reportNum = this.$route.query.approvalNum
    this.seletionRangeData.submitPresonNum = this.$route.query.personNum
    this.getOverviewList()
  },
  methods: {
    getDate (format="yyyy-MM-dd", type) {
      let date = null
      type = type || 'today'
      let now = +Date.now()
      let oneDay = 1000 * 60 * 60 * 24
      let yesterday = now - oneDay
      const typeDes = ["yesterday", "today"]
      if (typeDes.includes(type)) {
        date =  type === 'yesterday' ? new Date(yesterday) : new Date()
      } else {
        date = new Date(type)
      }
      if (date.toString() === 'Invalid Date') {
        return
      } 
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ?
            (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return format;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onRangeTypeConfirm (range) {
      this.showRangeType = false
      if (this.seletionRangeData.currentRange === range?.modelName) {
        return
      }
      this.seletionRangeData.currentRange = range?.modelName
      this.seletionRangeData.modelId = range?.modelId
      this.pageInfo.currentPage = 1
      this.overviewList = []
      this.onLoad()
      this.queryPersonalReportBoard()
    },
    async queryPersonalReportBoard () {
      let [error, data] = await this.to(getPersonalReportBoard({
        "scopeType": this.companyInfo.scopeType,
        "companyId": this.companyInfo.companyId,
        "officeId": this.companyInfo.officeId,
        "date": this.seletionDateData.selectedDate,
        modelId: this.seletionRangeData.modelId
      }))

      if (error) {
        this.error = true
        return Toast.fail("获取总览列表失败")
      }

      if (data) {
        this.seletionRangeData.reportNum = data.approvalNum
        this.seletionRangeData.submitPresonNum = data.personNum
      } 
    },
    dateConfirm (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = `${y}-${m < 10 ? '0' + m : m}`
      this.showDatePicker = false
      if (this.seletionDateData.selectedDate === d) {
        return
      }
      this.seletionDateData.selectedDate = `${y}-${m < 10 ? '0' + m : m}`
      this.overviewList = []
      this.pageInfo.currentPage = 1
      this.onLoad()
      this.queryPersonalReportBoard()
    },
    onSearch (searchData) {
      this.searchData = searchData
      this.overviewList = []
      this.pageInfo.currentPage = 1
      this.onLoad()
    },
    selectCompanyHandler () {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany)
        }
      })
    },

    async getRangeOptions () {
        console.log(this.rangeParams)
        let [error, data] = await this.to(getRangeOptionsList({
          companyId: this.rangeParams.companyId,
          scopeType: this.rangeParams.scopeType
        }))

        if (error) {
          this.error = true
          return Toast.fail("获取审批模板失败")
        }
        if (data) {
          this.rangeTypeOptions = data
          if (!this.rangeTypeOptions.find((el) => el.modelName === "全部流程")) {
            this.rangeTypeOptions.unshift({
              modelId: "",
              modelName: "全部流程"
            })
          }
        }
    },
    async getOverviewList () {
      let { currentPage, currentPageSize } = this.pageInfo
      let [error, data] = await this.to(getReportOverviewList({
          currentPage,
          currentPageSize,
          modelId: this.seletionRangeData.modelId,
          scopeType: this.companyInfo.scopeType,
          searchWord: this.searchData ,
          companyId: this.companyInfo.companyId,
          officeId: this.companyInfo.officeId,
          date: this.seletionDateData.selectedDate 
      }))
      this.loading = false;
      if (error) {
        this.error = true
        return Toast.fail("获取总览列表失败")
      }
     
      if (data) {
        let { records, total } = data
        if (this.refreshing) {
          this.overviewList = [];
          this.refreshing = false;
        }
        this.overviewList = this.overviewList.concat(records)
        if (this.overviewList.length >= total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      } 
    },
    toFlowDeital (instanceId, initiatorName) {
      this.$router.push({
        path: "report-detail",
        query: {
          instanceId,
          initiatorName
        }
      })
    },
    onClickLeft () {
      this.$router.back()
    },
    selectDateHandler (date) {
      this.showDatePicker = true
    },
    selectRangeHandler () {
      this.showRangeType = true
    },
     onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageInfo.currentPage = 1
      this.onLoad();
    },
    onLoad() {
      this.getOverviewList()
      this.pageInfo.currentPage ++
    },
    to (promise, errorFirst = true) {
      return promise.then(data => {
        let { code, msg, data: res } = data.data
        if (code == 0) {
          return errorFirst ? [null, res] : [null, res]
        } else {
          Toast.fail(msg)
          return errorFirst ? [null, null] : [null, null]
        }
      }).catch(err => {
        return errorFirst ? [err, null] : [null, err]
      }) 
    }
  },
  watch: {
    '$route.query': {
      handler (query) {
        if (query.id == 0) {
          console.log(22222222)
        }
      },
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/select-data-range' || from.path === '/personal-report-board') {
      next(vm => {
        let params = null
        if (from.path === '/select-data-range') {
          params = from.params?.selectedData || []
        } else if (from.path === '/personal-report-board') {
          let rangeTypeIndex = vm.rangeTypeOptions.findIndex((el) => el.modelName === "全部流程")
          if (rangeTypeIndex > -1) {
            let rangeType = vm.rangeTypeOptions[rangeTypeIndex]
            vm.seletionRangeData.modelId = rangeType.modelId
            vm.seletionRangeData.currentRange = rangeType.modelName
            vm.$refs.rangeType && vm.$refs.rangeType.setColumnIndex(0, rangeTypeIndex)
          }
          params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : []
          let selcetDate = to.query?.selectionDate
          vm.seletionDateData.selectedDate = selcetDate
          vm.selectedDate = new Date(selcetDate)
        }
        if (params.length) {
          vm.selectedCompany = params
          let selected = params[params.length -1]
          vm.seletionData.company = selected?.name
          vm.companyInfo.scopeType = selected?.type
          vm.rangeParams.companyId = selected?.companyId || selected?.id
          vm.rangeParams.scopeType = selected.type == 2 ? 1 : selected.type
          if (selected.type == 0 || selected.type == 1) {
            vm.companyInfo.companyId = selected.id
            vm.companyInfo.officeId = ""
          } else if (selected.type == 2) {
            vm.companyInfo.companyId = ""
            vm.companyInfo.officeId = selected.id
          }
          vm.pageInfo.currentPage = 1
          vm.overviewList = []
          vm.queryPersonalReportBoard()
          vm.getRangeOptions()
          vm.onLoad()
        }
      });
    } else {
      next()
    }
  },
 
} 
</script>

<style scoped>
.date-selection-warpper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  margin: 10px 0;
}
.date-selection {
  display: flex;
}
.flex-warpper {
 display: flex;
  align-items: center;
}
.company-arrow {
  font-size: 18px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.company-selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}

.date-selection span {
  color: #666;
  margin-right: 5px;
}

.date-show {
  font-size: 12px;
  color: #999;
}

.vei-mid {
  vertical-align: baseline;
}
.border-r {
  padding-right: 10px;
  position: relative;
}

.border-r::after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 10px;
  background-color: #999;
  position: absolute;
  right: 0;
  top: 4px;
}
.number-area {
  color: #666;
  font-size: 12px;
}

.font-s-12 {
  font-size: 12px;
}
.report-list-warpper {
  height: 62vh;
  overflow-y: scroll;
}
.padding-l {
  padding-left: 10px;
}

.marin-0 {
  margin-top: 0;
  margin-bottom: 0;
}
.van-cell {
  align-items: center;
  line-height: auto;
}
.add-border {
   height: 26px;
  border: 1px solid #ddd;
  border-radius:4px;
  padding: 0 8px;
}

.head-portrait {
  width: 40px;
  height: 40px;
  margin-right: 16px;
}

.reporter-info {
  display: flex;
  align-items: center;
}

.author {
  font-size: 14px;
  color: #333;
}

.flowName, .submitTime span{
  font-size: 13px;
  color: #666;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>